export const mostSearched = [
  '1',
  '4',
  '7',
  '11',
  '14',
  '15',
  '18',
  '22',
  '27',
  '28',
  '30',
  '31',
  '32',
  '33',
  '35',
  '39',
  '40',
  '44',
  '46',
  '47',
  '48',
  '69',
  '222',
  '1011'
]

export const CHEAP_NEW_VEHICLE_PRICE = 19000

export const VEHICLE_SPECS_CONTEXT = {
  HIRED_MAKES: 'hired-makes',
  MAKE: 'makes',
  MODEL: 'models',
  MODELS_VERSION: 'models-version',
  VERSION: 'versions'
}

export const VEHICLE_EXTRAS_FIELD = {
  COLOR: 'color',
  EQUIPMENT: 'equipment'
}

export const VEHICLE_SPEC_PARAMS = {
  MANUAL_ITEMS: {includeManual: true},
  MARKETED_ITEMS: {onlyInCommercialization: true}
}

export const HAS_JATO = true

export const MAKE_ID_LOGOS_MAP = {
  1: 'LogoAlfaromeo',
  4: 'LogoAudi',
  7: 'LogoBmw',
  11: 'LogoCitroen',
  14: 'LogoFiat',
  15: 'LogoFord',
  18: 'LogoHyundai',
  21: 'LogoJeep',
  22: 'LogoKia',
  25: 'LogoLexus',
  27: 'LogoMazda',
  28: 'LogoMercedes',
  30: 'LogoMitsubishi',
  31: 'LogoNissan',
  32: 'LogoOpel',
  33: 'LogoPeugeot',
  35: 'LogoRenault',
  39: 'LogoSeat',
  40: 'LogoSkoda',
  41: 'LogoSmart',
  44: 'LogoSuzuki',
  46: 'LogoToyota',
  47: 'LogoVolkswagen',
  48: 'LogoVolvo',
  69: 'LogoHonda',
  222: 'LogoMini',
  1011: 'LogoDacia',
  1330: 'LogoAbarth',
  1345: 'LogoBugatti',
  1352: 'LogoByd',
  1354: 'LogoTesla',
  1377: 'LogoAlpine',
  1400: 'LogoCupra',
  1402: 'LogoPolestar'
}
